import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import Button, { buttonClasses } from "../Button/Button";

interface UserAccountMenuProps {
  onClose: () => void;
  onLogout: () => void;
  onCartAuth?: (tab: 'login' | 'register') => void;
}

const UserAccountMenu = ({ onClose, onLogout, onCartAuth }: UserAccountMenuProps) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const isFullyAuthenticated = !!user && !user.requiresContactInfoUpdate;

  const go = (path: string) => {
    onClose();
    navigate(path);
  };

  if (isFullyAuthenticated) {
    return (
      <div className="flex flex-col text-sm">
        <p className="px-4 py-3 font-bold text-gray-700 border-b">
          OLÁ, {user.firstName?.toUpperCase() ?? "CLIENTE"}!
        </p>
        <button onClick={() => go("/meus-dados")} className="w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b transition-colors">
          Meus dados
        </button>
        <button onClick={() => go("/pedidos")} className="w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b transition-colors">
          Meus pedidos
        </button>
        <button onClick={() => { onLogout(); onClose(); }} className="w-full text-left px-4 py-3 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors">
          Sair
        </button>
      </div>
    );
  }

  return (
    <div className="p-4 text-center">
      {onCartAuth ? (
        <Button
          type="button"
          onClick={() => { onClose(); onCartAuth('login'); }}
          className="py-2 px-4 w-full block"
        >
          ENTRAR
        </Button>
      ) : (
        <Link to="/login" onClick={onClose} className={buttonClasses("primary", "py-2 px-4 w-full block")}>
          ENTRAR
        </Link>
      )}
      <p className="mt-3 text-gray-600 text-xs">Não tem cadastro?</p>
      {onCartAuth ? (
        <button type="button" onClick={() => { onClose(); onCartAuth('register'); }} className="text-primary-600 font-semibold text-sm hover:text-primary-700 hover:underline">
          Cadastrar
        </button>
      ) : (
        <Link to="/cadastro" onClick={onClose} className="text-primary-600 font-semibold text-sm hover:text-primary-700 hover:underline">
          Cadastrar
        </Link>
      )}
    </div>
  );
};

export default UserAccountMenu;
